module.exports = __webpack_public_path__ + "static/img/login-bg-english.c36c28b5.png";